import React from "react";

import {Container, GrapeIcon, LocationCard, LocationIcon, Title,} from "./styles";
import {IProduct} from "../../redux/productReducer";
import type {FilterReducer} from "../../../Filters/redux/filtersReducer";
import CircularIndeterminate from "../../../../../common/components/LoadingScreen/LoadingComponent";

const SellerInfo: (props: { product: IProduct, filtros: FilterReducer }) => JSX.Element = (props: { product: IProduct, filtros: FilterReducer }) => {

    const {listaPais = []} = props.filtros
    const {product = {}} = props
    const [loadedSrc, setLoadedSrc] = React.useState(null);
    const onImageLoad = (e: any) => setLoadedSrc(e.target.currentSrc);

    const imageVariants = [
        {
            url: (listaPais.length && product.countryId) && listaPais.find(pais => pais.countryId === product.countryId).countryFlagImageURL,
            width: 500
        },
        {
            url: (listaPais.length && product.countryId) && listaPais.find(pais => pais.countryId === product.countryId).countryFlagImageURL,
            width: 1000
        },
        {
            url: (listaPais.length && product.countryId) && listaPais.find(pais => pais.countryId === product.countryId).countryFlagImageURL,
            width: 3200
        }
    ];

    const srcSet = imageVariants
        .map(variant => `${variant.url} ${variant.width}w`)
        .join(",");

    return (
        <Container>
            <Title>Informações do vinho</Title>

            {(listaPais.length && product.countryId) && (
                <>
                    <LocationCard>
                        <picture>
                            <source type="image/webp" srcSet={(listaPais.length && product.countryId) && listaPais.find(pais => pais.countryId === product.countryId).countryFlagImageURL}/>
                            <source type="image/png" srcSet={(listaPais.length && product.countryId) && listaPais.find(pais => pais.countryId === product.countryId).countryFlagImageURL}/>
                            <source type="image/jpg" srcSet={(listaPais.length && product.countryId) && listaPais.find(pais => pais.countryId === product.countryId).countryFlagImageURL}/>
                            <source type="image/jpeg" srcSet={(listaPais.length && product.countryId) && listaPais.find(pais => pais.countryId === product.countryId).countryFlagImageURL}/>
                            <CircularIndeterminate componentShow={(
                                <LocationIcon
                                    alt={`${product.wineName} ${(listaPais.length && product.countryId) && listaPais.find(pais => pais.countryId === product.countryId).countryName} `}
                                    src={(listaPais.length && product.countryId) && listaPais.find(pais => pais.countryId === product.countryId).countryFlagImageURL}
                                    onLoad={onImageLoad}
                                    srcSet={srcSet}
                                />
                            )} />

                        </picture>

                        <div>
                            <p>{(listaPais.length && product.countryId) && listaPais.find(pais => pais.countryId === product.countryId).countryName}</p>
                        </div>
                    </LocationCard>
                </>
            )}


            <LocationCard>
                <GrapeIcon/>

                <div>
                    <p>{props.product.grapeTypeName}</p>
                </div>
            </LocationCard>
        </Container>
    );
};

export default SellerInfo;
